module.exports = __webpack_public_path__ + "img/icon-loading.83458905.svg";